import { render } from "./EditCardSkeleton.vue?vue&type=template&id=649d0fa1&ts=true"
import script from "./EditCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./EditCardSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__